import DescriptionsPrefix from './descriptions-prefix';

export default DescriptionsPrefix;
